module.exports = __webpack_public_path__ + "static/media/circle-check.1f284fb6.svg";